import { createAction } from 'redux-actions'
import yoyi from 'src/helpers/fetch/fetchService'
import { labelApi } from 'src/utils/path'
import { message } from 'antd'
import { 
    configLabelDetail, 
    configBehaviorList, 
    configLabelList,
    configBatchOnline,
    configTreeList,
    configTreeStatus,
    configTreeAdd,
    configTreeUpdate,
    configLabelUpdate,
    configLabelInsert,
    configTreeLabelList
} from 'src/api/configCenter'

export const RECEIVE_TREE_LIST = 'RECEIVE_TREE_LIST'
export const RECEIVE_TREE_LABEL_LIST = 'RECEIVE_TREE_LABEL_LIST'
export const RECEIVE_RIGHT_TREE_LIST = 'RECEIVE_RIGHT_TREE_LIST'
export const SET_SELECT_NODE = 'SET_SELECT_NODE'
export const SET_APP_FIELDS = 'SET_APP_FIELDS'
export const GET_LABEL_INFO = 'GET_LABEL_INFO'
export const PUSH_LABEL_FORM_INFO = 'PUSH_LABEL_FORM_INFO'
export const GET_LABEL_INFO_LOADING = 'GET_LABEL_INFO_LOADING'
export const ADD_LABEL_INFO = 'ADD_LABEL_INFO'
export const RECEIVE_RENDER_SWICH = 'RECEIVE_RENDER_SWICH'
export const RECEIVE_RULE_LIST = 'RECEIVE_RULE_LIST'


// ------------------------------------
// Actions
// ------------------------------------
export const receiveTreeList = createAction(RECEIVE_TREE_LIST)
export const receiveTreeLabelList = createAction(RECEIVE_TREE_LABEL_LIST)
export const receiveRightTreeList = createAction(RECEIVE_RIGHT_TREE_LIST)
export const saveSelectNode = createAction(SET_SELECT_NODE)
export const saveAppFields = createAction(SET_APP_FIELDS)
export const getLabelInfo = createAction(GET_LABEL_INFO)
export const pushLabelFormInfo = createAction(PUSH_LABEL_FORM_INFO)
export const getLabelInfoLoading = createAction(GET_LABEL_INFO_LOADING)
export const receiveAddLabelInfo = createAction(ADD_LABEL_INFO)
export const recieveRenderSwich = createAction(RECEIVE_RENDER_SWICH)
export const receiveRuleList = createAction(RECEIVE_RULE_LIST)

// 标签树父级列表
export const fetchTreelist = payload => async (dispatch) => {
    try {
        // const response = await yoyi.get('labelTree/list', payload, {apiHost: labelApi})
        const response = await configTreeList(payload)
        dispatch(receiveTreeList(response))
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 标签树标签列表
export const fetchTreeLabelList = payload => async (dispatch) => {
    try {
        // const response = await yoyi.get('/v1/lable/getByTreeId', payload, {apiHost: labelApi})
        const response = await configTreeLabelList(payload)
        dispatch(receiveTreeLabelList(response))
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 设置选中节点
export const setSelectNode = payload => async (dispatch) => {
    try {
        dispatch(saveSelectNode(payload))
    }catch(e){
        message.error('设置失败')
        yoyi.exceptionMessage(e)
    }
}

// 设置右侧树选中节点
export const setAppFields = payload => async (dispatch) => {
    try {
        dispatch(saveAppFields(payload))
    }catch(e){
        message.error('设置失败')
        yoyi.exceptionMessage(e)
    }
}

// 右边标签树列表
export const fetchRightTreelist = payload => async (dispatch) => {
    try {
        // const response = await yoyi.get('rule/tableMetaList', payload, {apiHost: labelApi})
        const response = await configLabelList(payload)
        dispatch(receiveRightTreeList(response))
        return response
    }catch(e){
        return yoyi.exceptionMessage(e)
    }
}

// 创建分类
export const createCategory = payload => async (dispatch) => {
    try {
        // const response = await yoyi.post('labelTree/add', payload, {apiHost: labelApi})
        const response = await configTreeAdd(payload)
        dispatch(saveSelectNode(response))
        message.info('创建成功')
    }catch(e){
        message.error('创建失败')
        yoyi.exceptionMessage(e)
    }
}

// 编辑分类
export const updateCategory = payload => async (dispatch) => {
    try {
        // const response = await yoyi.post('labelTree/update', payload, {apiHost: labelApi})
        await configTreeUpdate(payload)
        message.info('编辑成功')
    }catch(e){
        message.error('编辑失败')
        yoyi.exceptionMessage(e)
    }
}

// 删除分类/批量上线
export const deleteLabel = payload => async (dispatch) => {
    try {
        // const response = await yoyi.post('labelTree/updateStatus', payload,  {apiHost: labelApi})
        await configTreeStatus(payload)
        message.info(`${payload.status == 1 ? '批量上线' : payload.status == 3 ? '下线' :  '删除'}成功`)
    }catch(e){
        message.error(`${payload.status == 1 ? '批量上线' : payload.status == 3 ? '下线' : '删除'}失败`)
        yoyi.exceptionMessage(e)
    }
}

// 添加标签
export const addLabel = (payload, isEdit) => async (dispatch) => {
    try {
        // const url = isEdit ? 'label/update' : 'label/insert'
        // const response = await  yoyi.post(url, payload, {apiHost: labelApi})
        const method = isEdit ? configLabelUpdate : configLabelInsert
        const response = await method(payload)
        dispatch(receiveAddLabelInfo(response))
        if (isEdit) {
            message.info('编辑成功')
        } else {
            message.info('添加成功')
        }
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 编辑标签
export const updateLabel = payload => async (dispatch) => {
    try {
        // const response = await yoyi.post('label/update', payload, {apiHost: labelApi})
        const response = await configLabelUpdate(payload)
        dispatch(receiveAddLabelInfo(response))
        message.info('编辑成功')
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 获取标签
export const getLabel = payload => async (dispatch) => {
    try {
        dispatch(getLabelInfoLoading(true))
        // const response = await yoyi.get('label/get', payload, {apiHost: labelApi})
        const response = await configLabelDetail(payload)
        dispatch(getLabelInfo(response))
        dispatch(getLabelInfoLoading(false))
    }catch(e){
        message.error('获取标签信息失败!')
        yoyi.exceptionMessage(e)
    }
}

// 获取标签
export const clearLabelInfo = payload => async (dispatch) => {
    try {
        dispatch(getLabelInfo({}))
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 获取行为的列表
export const fetchRuleList = payload => async (dispatch) => {
    try {
        // const response = await yoyi.get('rule/ruleParamList', payload, {apiHost: labelApi})
        const response = await configBehaviorList(payload)

        dispatch(receiveRuleList(response))
        return response
    }catch(e){
        return yoyi.exceptionMessage(e)
    }
}

// 设置渲染开关
export const setRenderSwich = payload => async (dispatch) => {
    try {
        dispatch(recieveRenderSwich(payload))
    }catch(e){
        yoyi.exceptionMessage(e)
    }
}

// 批量上线
export const fetchBatchOnline = payload => async (dispatch) => {
    try {
        // await yoyi.post('labelTree/batchOnline', payload, { apiHost: labelApi })
        await configBatchOnline(payload)
        message.info(`批量上线成功`)
    }catch(e){
        message.error(`批量上线失败`)
        yoyi.exceptionMessage(e)
    }
}
